import React from "react"
import { Tooltip } from "@mui/material"

export const CoveringTooltip = ({ title, children }: { title: string, children: React.ReactElement<any, any> }) => {
  return (
    <Tooltip
      placement="bottom"
      title={title}
      PopperProps={{
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -35]
            }
          }
        ]
      }}
    >
      {children}
    </Tooltip>
  )
}
